(function () {
  document.querySelectorAll('[data-shop-grid-toolbar]').forEach(function (toolbar) {
    var section = toolbar.closest('.campaign-shop-grid');
    var grid = section.querySelector('[data-shop-grid]');
    var filterButtons = toolbar.querySelectorAll('[data-filter]');
    var sortSelect = toolbar.querySelector('[data-shop-grid-sort]');

    filterButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        filterButtons.forEach(function (b) {
          b.classList.remove('is-active');
        });
        button.classList.add('is-active');

        var type = button.getAttribute('data-filter');
        grid.querySelectorAll('[data-product-type]').forEach(function (card) {
          var matches = type === 'all' || card.getAttribute('data-product-type') === type;
          card.style.display = matches ? '' : 'none';
        });
      });
    });

    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sortSelect.value);
        window.location.href = url.toString();
      });
    }
  });
})();